<template>
    <div>
        <v-dialog :modelValue="dialog_view" max-width="600" @click:outside="close" @keydown.esc="close">
            <v-card>
                <v-card-title class="headline">
                    {{ title }} - LPN: {{ lpn_code }} 
                </v-card-title>

                <v-card-text>

                    <div class="row">
                        <div class="col-md-12">
                            <v-data-table :headers="headers" :items="list" :search="search" :loading="loading"
                                loading-text="Cargando..." :hide-default-footer="true">
                                <template v-slot:item="props">
                                    <tr>
                                        <td>{{ props.item.shipment_order_code }}</td>
                                    <td>
                                        <div class="status-badge font-weight-medium" :class="'status-envio-' + props.item.shipment_order_status.id">
                                            {{ props.item.shipment_order_status.name }}
                                            <p class="text-caption text-grey-600 mb-0">{{ props.item.shipment_order_status.name }}</p>
                                        </div>

                                    </td>
                                    </tr>
                                </template>
                                <template v-slot:no-results>
                                    <v-alert :value="true" color="error" icon="warning">
                                        {{ "Busqueda sin resultados - " + search }}
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="red darken-1" text @click="close()"> Cerrar </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import { inventoryService } from "@/libs/ws/inventoryService";

export default {
    components: {},
    mixins: [],
    props: {
        title: String,
        dialog_view: Boolean,
        lpn_id: Number,
        lpn_code: String,
        product_id: Number,
    },
    data: () => ({
        list: [],
        formatUtils: formatUtils,
        defaultItem: null,
        loading: false,
        search: "",
        headers: [
            { title: "Código Pedido", align: "left", sortable: true, key: "shipment_order_code" },
            { title: "Estado", align: "left", sortable: true, key: "shipment_order_status" },
        ],
 
    }),
    created: function () {
        window.addEventListener("keydown", (e) => {
            if (e.key == "Escape") {
                this.close();
            }
        });
    },
    watch: {
        dialog_view(val) {
            if (val) {
                this.loadList();
            }
        },
    },
    mounted() { },
    methods: {
        updatePagination(pagination) {
            this.pagination = pagination;
        },

        close() {
            this.list = [];
            this.$emit("closeDialog");
        },

        loadList() {
            this.loading = true;

            const param = {
                lpn_id: this.lpn_id,
                product_id: this.product_id,
            };

            inventoryService
                .get_shipment_orders_by_lpn(param)
                .then((response) => {
                    this.list = response.result.list;
                    this.loading = false;
                })
                .catch((e) => {
                    console.log("service.get_shipment_orders_by_lpn error");
                    console.log(e);
                    this.loading = false;
                });
        },

    },
};
</script>